import { render, staticRenderFns } from "./DashboardEmpty.vue?vue&type=template&id=476c1fba&scoped=true&"
import script from "./DashboardEmpty.vue?vue&type=script&lang=js&"
export * from "./DashboardEmpty.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEmpty.vue?vue&type=style&index=0&id=476c1fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476c1fba",
  null
  
)

export default component.exports